import { render, staticRenderFns } from "./hzv2.vue?vue&type=template&id=d33ed3f6&scoped=true"
import script from "./hzv2.vue?vue&type=script&lang=js"
export * from "./hzv2.vue?vue&type=script&lang=js"
import style0 from "./hzv2.vue?vue&type=style&index=0&id=d33ed3f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33ed3f6",
  null
  
)

export default component.exports